import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { formattedDateTime } from "../../../../constants/phase";
import { BackTitle } from "../../../icons";

const OpsTabsHeader = (props) => {
  const { pathname } = useLocation();
  const { streamId } = useParams();
  const { organisationId } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [streamData, setStreamData] = useState([]);
  const { getStreamDetails } = props;
  const path = `/ops/organization/${organisationId}/streams/${streamId}`;

  const fetchStreamById = async () => {
    const { value } = await getStreamDetails(streamId);
    setStreamData(value?.stream ?? null);
    setLoader(!value?.success);
  };

  useEffect(() => {
    fetchStreamById();
  }, []);

  return (
    <>
      <div style={{ height: 70 }}></div>
      <div className="container-od">
        <div className="page-title-od stream-create-header">
          <div className="tab-back-container">
            <button className="backtitle-arrow" onClick={() => navigate(`/ops/organization/${organisationId}/streams`)}>
              <BackTitle />
            </button>
            <div className="ops-tab-content-cell ms-3">
              <div className="ops-tab-content">
                <button
                  className={`${pathname}` === `${path}/extraction` ? "active" : ""}
                  onClick={() => navigate(`${path}/extraction`)}
                >
                  Clip Creator
                </button>
                {/* <button
                  className={`${pathname}` === `${path}/ai-ds-marks` ? "active" : ""}
                  onClick={() => navigate(`${path}/ai-ds-marks`)}
                >
                  AI/DS Marks
                </button> */}
                <button
                  className={`${pathname}` === `${path}/clip-library` ? "active" : ""}
                  onClick={() => navigate(`${path}/clip-library`)}
                >
                  Clips Library
                </button>
              </div>
            </div>
          </div>
          <div className="center-clip-block">
            {loader ? (
              "Loading..."
            ) : (
              <>
                <h5>{formattedDateTime(streamData, "date")}</h5>
                <span>{formattedDateTime(streamData, "time")} • (IST)</span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OpsTabsHeader;
